import React from "react";
import styles from "./style.scss";
import { Source } from "./Source";
import { Dialog } from "./Dialog";
import { Chat as ChatType, DownloadType, Reference } from "models/AiResearch";

interface Props {
  chat: ChatType;
  selectedReference?: Reference | null;
  handleShowReference: ({
    questionId,
    referenceId
  }: {
    questionId: string;
    referenceId: number;
  }) => void;
  handleCopy: ({ chatIndex }: { chatIndex: number }) => void;
  handleDownload: ({
    type,
    questionId
  }: {
    type: DownloadType;
    questionId: string;
  }) => void;
  onChatTitleEdit: (newTitle: string) => void;
  onChatDelete: () => void;
  onReuseText: (text: string) => void;
  onRetry: () => void;
}

export const Chat: React.FC<Props> = ({
  chat,
  selectedReference,
  handleShowReference,
  handleCopy,
  handleDownload,
  onChatTitleEdit,
  onChatDelete,
  onReuseText,
  onRetry
}) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.source}>
        <Source
          title={chat.title}
          disabled={!Boolean(chat.talkId)} // トークIDがない場合は編集・削除ができないため disabled にする
          onChatTitleEdit={onChatTitleEdit}
          onChatDelete={onChatDelete}
        />
      </div>
      <Dialog
        chat={chat}
        selectedReference={selectedReference}
        handleShowReference={handleShowReference}
        handleCopy={handleCopy}
        handleDownload={handleDownload}
        onReuseText={onReuseText}
        onRetry={onRetry}
      />
    </div>
  );
};
